const getNGrams = ({ text, nGram }: { text: string; nGram: number }) => {
  const words = text.toLowerCase().split(/\s+/);

  const ngrams = [];

  for (let i = 0; i <= words.length - nGram; i++) {
    ngrams.push(words.slice(i, i + nGram).join(" "));
  }
  return new Set(ngrams);
};

export const nGramSimilarity = ({
  fullText,
  searchString,
  nGram = 3,
}: {
  fullText: string;
  searchString: string;
  nGram?: number;
}) => {
  // Function to calculate Jaccard similarity using n-grams
  const set1 = getNGrams({ text: fullText, nGram });
  const set2 = getNGrams({ text: searchString, nGram });

  const intersection = new Set([...set1].filter((x) => set2.has(x)));
  const union = new Set([...set1, ...set2]);

  return intersection.size / union.size;
};
